import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class Animations {

    constructor() {

        this.animationBlocks = document.querySelectorAll('[data-block-animate]');
        this.animateOnLoadBlocks = document.querySelectorAll('[data-animate-on-load]');
        this.animateHeroBlock = document.querySelector('[data-animate-hero]');

        this.triggerStart = 'top +=80%';
        this.triggerEnd = 'bottom -65%';

        if (window.innerWidth < 772) {
            this.triggerStart = 'top +=85%';
            this.triggerEnd = 'bottom -85%';
        }

        if (this.animationBlocks.length) {
            this.init();
        }

        if (this.animateOnLoadBlocks.length) {
            this.animateOnLoad();
        }

        this.animateHeroBlockLoad(this.animateHeroBlock);

        this.initPipeAnimation();

        this.initYTVideoPlay();

    }

    init() {

        const self = this;

        this.animationBlocks.forEach(animationBlock => {

            const contentParts = animationBlock.querySelectorAll('[data-animate-part]');

            ScrollTrigger.create({
                trigger: animationBlock,
                start: self.triggerStart,
                end: self.triggerEnd,
                once: true,
                // markers: true,
                onEnter: (self) => {
                    gsap.fromTo(animationBlock, {autoAlpha: 0}, {autoAlpha: 1, duration: 1});

                    if (contentParts.length) {
                        gsap.fromTo(contentParts, {autoAlpha: 0, y: 50}, {
                            autoAlpha: 1,
                            y: 0,
                            delay: 0.3,
                            duration: 1,
                            stagger: 0.1
                        });
                    }
                },
            });
        });
    }

    animateOnLoad() {

        const scaleDown = document.querySelector('[data-animate-scale-down]');
        const fadeUp = document.querySelector('[data-animate-on-load-fade-up]');

        window.addEventListener('load', () => {
            gsap.fromTo(scaleDown, {scale: 1.2}, {scale: 1, duration: 1});
            gsap.fromTo(fadeUp, {autoAlpha: 0}, {autoAlpha: 1, duration: 1});
            this.animateOnLoadBlocks.forEach(block => {
                gsap.to(block, {autoAlpha: 1, duration: 1});
            });
        });

    }

    animateHeroBlockLoad(block) {

        if(!block) return;

        const pipeElements = block.querySelectorAll('[data-hero-pipe] svg path');

        if(window.innerWidth > 1200) {

            // Setup svg animation
            pipeElements.forEach(pipeElement => {

                const length = pipeElement.getTotalLength();
                let lengthDashoffset = length;

                if(pipeElement.classList.contains('reverse')) {
                    lengthDashoffset = -length;
                }

                pipeElement.style.strokeDasharray = length;
                pipeElement.style.strokeDashoffset = lengthDashoffset;
            });
        }


        const scaleDown = block.querySelector('[data-animate-scale-down]');
        const content = block.querySelectorAll('[data-animate-content]');
        const logo = document.querySelector('[data-animate-logo]');
        const styleElement = block.querySelector('.style-elements');

        window.addEventListener('load', () => {

            gsap.fromTo(scaleDown,{scale: 1.1 }, {scale: 1, duration: 1});
            gsap.fromTo(content, {autoAlpha: 0, y: 50}, {autoAlpha: 1, y: 0, delay: 0.3, duration: 1, stagger: 0.1});

            if(logo) {
                gsap.fromTo(logo, {width: 0}, {width: '100vw', delay: 1, duration: 1});
            }

            if(styleElement) {
                styleElement.style.opacity = 1;
            }

            gsap.to(pipeElements, {strokeDashoffset: 0, duration: 2, stagger: 0.28, delay: 1.25});

        }, 200);

    }

    initPipeAnimation() {

        const pipeAnimationBlocks = document.querySelectorAll('[data-pipe-animation]');

        if(!pipeAnimationBlocks.length) return;

        let selector = 'data-pipe';

        if(window.innerWidth < 1200) {
            selector = 'data-mobile-pipe';
        }

        pipeAnimationBlocks.forEach(block => {

            const pipeElements = block.querySelectorAll(`[${selector}] svg line, [${selector}] svg path`);

            // Setup svg animation
            pipeElements.forEach(pipeElement => {

                const length = pipeElement.getTotalLength();
                let lengthDashoffset = length;

                if(pipeElement.classList.contains('reverse')) {
                    lengthDashoffset = -length;
                }

                pipeElement.style.strokeDasharray = length;
                pipeElement.style.strokeDashoffset = lengthDashoffset;
            });

            ScrollTrigger.create({
                trigger: block,
                start: 'top +=55%',
                end: 'bottom -55%',
                once: true,
                // markers: true,
                onEnter: (self) => {
                    gsap.to(pipeElements, {strokeDashoffset: 0, duration: 2, stagger: 0.48});
                },
            });
        });
    }

    initYTVideoPlay() {
        const videoBlocks = document.querySelectorAll('[data-animate-play-yt]');
        const isIphone = /iPhone/.test(navigator.userAgent);

        let hasUserInteracted = false;

        // Detect user interaction (click, keydown, or touchstart)
        const userInteractionHandler = () => {
            hasUserInteracted = true;

            // Unregister event listeners to prevent multiple triggers
            window.removeEventListener('click', userInteractionHandler);
            window.removeEventListener('keydown', userInteractionHandler);
            window.removeEventListener('touchstart', userInteractionHandler);
        };

        // Register event listeners for user interactions
        window.addEventListener('click', userInteractionHandler);
        window.addEventListener('keydown', userInteractionHandler);
        window.addEventListener('touchstart', userInteractionHandler);

        videoBlocks.forEach(videoBlock => {

            const video = videoBlock.querySelector('iframe');
            const playButton = videoBlock.querySelector('.btn-play');
            const originalSrc = video.src;

            if(playButton) {
                playButton.addEventListener('click', () => {
                    video.src += '?autoplay=1';
                    videoBlock.classList.add('playing');
                });
            }

            ScrollTrigger.create({
                trigger: videoBlock,
                start: 'center-=30% +=60%',
                end: 'center+=30% center',
                once: false,
                // markers: true,
                onEnter: (self) => {
                    video.src += '?autoplay=1&mute=1&rel=0';
                    videoBlock.classList.add('playing');
                },
                onLeave: () => {
                    video.src = originalSrc;
                    videoBlock.classList.remove('playing');
                },
                onEnterBack: (self) => {
                    video.src += '?autoplay=1&mute=1&rel=0';
                    videoBlock.classList.add('playing');
                },
                onLeaveBack: () => {
                    video.src = originalSrc;
                    videoBlock.classList.remove('playing');
                },
            });
        });

    }
}